import { v4 as uuid } from "uuid";
import CardBase from "components/General/CardBase";
import Field from "components/General/Field";
import GridBase from "components/General/GridBase";
import { isAgentPortal } from "js/utilities";

const CardWithFields = (props) => {
  const {
    additionalContent,
    ariaLabel,
    cardTitle,
    cardFields,
    additionalChildComponent = null,
    badgeClass = null,
  } = props;

  return (
    <CardBase
      additionalContent={additionalContent}
      ariaLabel={ariaLabel}
      cardTitle={cardTitle}
      badgeClass={badgeClass}
      additionalChildComponent={additionalChildComponent}
    >
      <GridBase>
        {cardFields.map((field) => (
          <Field
            key={`${field.title} - ${uuid()}`}
            title={field.title}
            value={field.value}
            hidden={field.hidden}
          />
        ))}
      </GridBase>
    </CardBase>
  );
};

export default CardWithFields;
